module.exports = __webpack_public_path__ + "static/img/facebook_icon.349870e.svg";